import { render, staticRenderFns } from "./1_m_glasses.vue?vue&type=template&id=24db9a16&scoped=true&"
import script from "./1_m_glasses.vue?vue&type=script&lang=js&"
export * from "./1_m_glasses.vue?vue&type=script&lang=js&"
import style0 from "./1_m_glasses.vue?vue&type=style&index=0&id=24db9a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db9a16",
  null
  
)

export default component.exports